import { render, staticRenderFns } from "./GaoDetai.vue?vue&type=template&id=738b113d&scoped=true"
import script from "./GaoDetai.vue?vue&type=script&lang=js"
export * from "./GaoDetai.vue?vue&type=script&lang=js"
import style0 from "./GaoDetai.vue?vue&type=style&index=0&id=738b113d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b113d",
  null
  
)

export default component.exports